import { FMSRStore } from 'app/store/store';
import { AxiosRequestConfig } from 'axios';

export const authInterceptor =
  (store: FMSRStore) =>
  async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
    const { jwt } = store.getState().workstation;
    // @ts-ignore
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${jwt}`;
    return config;
  };
